export const PaeConstants = {
    PAE: "PAE",
    PRIVILEGED: "PRIVILEGED",
    PARTICIPANT: "PARTICIPANT"
};
